<template>
  <v-container fluid class="py-0 my-0">
    <v-card>
      <v-system-bar>{{title}}</v-system-bar>
      <v-stepper
          v-if="!!state.stepList"
          :height="height"
          vertical
          class="text-sm-h2 text-lg-subtitle-1 overflow-y-auto"
          v-model="state.currentStep"
          @change="onStepperChange($event)"
          :key="!!state.stepList.length"
      >
      <span v-for="item of state.stepList" :key="item.step">
        <v-stepper-step
            :editable="item.editable"
            :step="item.step"
            :rules="[() => !item.error]"
        >
          <v-chip class="mr-3">{{ item.label }}</v-chip>
          <slot :name="[`text.${item.step}`]" :item="item">
            <v-chip v-if="!!item.text" label>
                {{ item.text }}
            </v-chip>
          </slot>
          <v-progress-linear
              v-if="item.load"
              indeterminate
              size="16"
              width="1"
              color="blue-grey lighten-1"
              class="ml-1 mr-n2"
          >
          </v-progress-linear>
        </v-stepper-step>
        <v-stepper-content :step="item.step">
          <slot :name="[`item.${item.step}`]" :item="item">
            {{ '' }}
          </slot>
        </v-stepper-content>
      </span>
      </v-stepper>
      <v-card-actions>
        <slot name="footer">{{ '' }}</slot>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>

import {defineStore} from "pinia";

export const useStepperStore = function (storeName) {
  let aggregateStore = useAggregateStore()
  return defineStore(storeName, {
        state: () => ({
          currentStep: 1,
          stepList: [],
          loading: false,
          dtoActionCommand: null,
          uidItem: null,
        }),
        getters: {},
        actions: {
          callBack() {
          },
          stepAction(actionName, actionUid, data = null, callReceive = null) {
            // console.log('stepAction', actionName, actionUid, data, callReceive)
            aggregateStore.fetchAction({
              storeName: this.$id,
              dtoActionCommand: this.dtoActionCommand,
              uidItem: this.uidItem,
              uidSelected: [],
              actionName: actionName,
              actionUid: actionUid,
              data: data,
              callBack: null,
              callReceive: callReceive
            })
          },
        }
      }
  )
}

import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useActionStore} from "@/components/Common/CommonBtnActionGroup";
import {useDetailStore} from "@/components/Common/CommonDetail";

export default {
  name: 'CommonStepper',
  inheritAttrs: false,
  props: {
    height: {default: null},
    storeName: {type: [String], default: 'CommonStepper'},
    dtoActionCommand: {type: [String], default: null},
    title: {default: null},
    data: {default: null},
  },

  components: {},

  computed: {},

  setup({storeName, dtoActionCommand}) {
    // console.log('setup', storeName)
    let state = useStepperStore(storeName)()
    state.dtoActionCommand = dtoActionCommand
    return {state}
  },

  methods: {
    onStepperChange(event) {
      console.log('onStepperChange', event)
      let stepList = []
      for (let item of this.state.stepList) {
        if (item.step === event)
          item.load = true
        stepList.push(item)
      }
      this.state.stepList = stepList
      this.state.stepAction('change_step', uuidv4(), {current_step: event}, this.updateStepList)
    },
    updateStepList(data) {
      // console.log('updateStepList', data, this.state)
      this.state.currentStep = data.action_state.action_results['current_step']
      this.state.stepList = structuredClone(data.action_state.action_results['step_list'])
    },
    isLoad() {
      let action_state = this.storeAction.actionsUid[this.actionUid]
      if (!!action_state)
        return action_state.load
    },
  },

  async mounted() {
    this.storeAction = useActionStore()()
    this.storeAggregate = useAggregateStore()
    this.state.stepAction('init', uuidv4(), this.data, this.updateStepList)
  },

  data() {
    return {
      storeStepper: null,
      storeAction: null,
      storeAggregate: null,
    }
  }
}
</script>

